import { Data as ArticleData } from '@root/modules/article/types/article';

export default function isFullWidthArticle(article: ArticleData) {
  return article.settings?.articleTemplate && article.settings?.articleTemplate === 'fullWidth';
}
